
// This source is part of the Akeria  and is
// copyrighted by Uniphore system software limited.

// All rights reserved.  No part of this work may be reproduced, stored in a
// retrieval system, adopted or transmitted in any form or by any means,
// electronic, mechanical, photographic, graphic, optic recording or otherwise,
// translated in any language or computer language, without the prior written
// permission of  Uniphore system software limited.

// Uniphore system software limited.
// Vaishnavi Silicon Terrace, B- Block, 
// 3rd & 4th floor, Hosur Rd, 
// Adugodi, Bengaluru, Karnataka 560095

// India

// Copyright 2019 Uniphore system software limited.

// Modification History

// Date            Version          Author                            Description
// ----------     -----------      ---------------                   ----------------------------------------
// 26 11 2019      1                Pappuraj                           address form Developed
// 30 11 2019      1.1              Pappuraj                           Bug fixed
//09-01-2020              Adhrish choudhary              mandatory prrof added 


import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController, Platform, ModalController, MenuController } from '@ionic/angular';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { Router } from '@angular/router';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { File } from '@ionic-native/file/ngx';
import { ActionSheetController, IonInput } from '@ionic/angular';
import { Base64 } from '@ionic-native/base64/ngx';
import { FilePath } from '@ionic-native/file-path/ngx';
import { FileChooser } from '@ionic-native/file-chooser/ngx';
import { DomSanitizer } from '@angular/platform-browser';
import { CountryListModal } from '../countrylistModal/countrylistModal.component';
import { IOSFilePicker } from '@ionic-native/file-picker/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
@Component({
    selector: 'app-addressupdate',
    templateUrl: './addressupdate.component.html',
    styleUrls: ['./addressupdate.component.scss'],
})
export class AddressUpdateComponent implements OnInit {
    @ViewChild('inputId', { static: false }) inputElement: IonInput;


    public addressform: FormGroup;
    languageConext: any;
    headerTitle: any;
    currentpath;
    formsubmitted: boolean = false;
    imagePickerOptions = {
        maximumImagesCount: 1,
        quality: 50
    };
    imgUrl: any;
    segment: any;
    profileDtls: any;
    selproof: any;
    TrustFrontImgFile: any;
    TrustBackImgFile: any;
    FrontImgFile: any;
    BackImgFile: any;
    FronImgName: any;
    BackImgName: any;
    agreecheck: any = false;
    FileSelected: any;
    Filearray: any;
    country: any;
    errormessage;
    pincheck: boolean = false;
    validPin: any;
    pincode: any;
    city;
    state;
    CountryList: any;
    address: any;
    addresstype: any;

    // maxLength : any;
    constructor(public formBuilder: FormBuilder,
        private router: Router,
        public navctrl: NavController,
        public platform: Platform,
        public cmndeclaration: CommonDeclarationService,
        public cmndef: CommonDefinitionService,
        private camera: Camera,
        public actionSheetController: ActionSheetController,
        private file: File,
        public api: RestapiService,
        public base64: Base64,
        public filePath: FilePath,
        public fileChooser: FileChooser,
        public _DomSanitizer: DomSanitizer,
        public modalCtrl: ModalController,
        public menuCtrl: MenuController,
        public iosfilepicker: IOSFilePicker,
        public statusBar: StatusBar) {
        this.currentpath = this.router.url;
        this.segment = 'permanent';
        this.profileDtls = [];
        this.Filearray = [];
        this.address = "";
        this.setDropDownlist();

        if (localStorage.getItem('language') == 'en') {
            this.addresstype = [
                {
                    "label1": "Permanent",
                    "value": "permanent",
                },
                {
                    "label1": "Correspondence",
                    "value": "correspondance",
                },
                {
                    "label1": "Both",
                    "value": "both",
                }
            ];
            this.segment = "permanent";
        }
        else {
            this.addresstype = [
                {
                    "label1": "परमानेंट",
                    "value": "permanent",
                },
                {
                    "label1": "कॉरेस्पॉन्डेंस",
                    "value": "correspondance",
                },
                {
                    "label1": "दोनों",
                    "value": "both",
                }
            ];
            this.segment = "permanent";
        }


        if (this.cmndeclaration.LanguageJson) {
            this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].address_update;
            console.log("a", this.languageConext.ownername);
        }
        else {
            this.cmndeclaration.LanguageJson = JSON.parse(localStorage.languageJson);
            this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].address_update;
            console.log("b", this.languageConext);
        }
        this.headerTitle = this.languageConext.heading.text;
        this.profileDetails();

        this.addressform = formBuilder.group({
            address: ['', Validators.required],
            pincode: ['', Validators.required],
            city: ['', Validators.required],
            state: ['', Validators.required],
            selproof: ['', Validators.required],
            country: ['', Validators.required],
            addresstype: ['', Validators.required],
            agreecheck: []
        });

        this.cmndeclaration.getstoreProcess("profile").then(data => {
            this.profileDtls = data;
            console.log(this.profileDtls);
            this.profileDetails();
        });
    }
    ngOnInit() {

    }

    ionViewWillEnter() {
        this.menuCtrl.swipeEnable(false);
    }
    async setDropDownlist() {
        let res: any;
        await this.cmndeclaration.getstoreProcess("nomineeCountry").then(data => {
            res = data
            this.CountryList = (res).split(",");
        });
    }

    profileDetails() {
        let params = {
            "userSessionID": localStorage.userSessionID,
            "userChatSessionId": localStorage.userChatSessionId,
            "mobileNo": this.profileDtls.mobileNo,
            "requestType": "getProfileData",
        }
        this.api.postapi("updateDetails", params).then(response => {
            this.profileDtls = response;
            this.segment == "permanent";
            if (this.profileDtls.permanentAddress.trim() == "") {
                this.profileDtls.permanentAddress = this.languageConext.permAddress.error;
            } else {
                this.profileDtls.permanentAddress = this.profileDtls.permanentAddress;
            }


            // console.log(response)
        })
    }

    imgs() {
        this.FronImgName = "";
        this.FrontImgFile = "";
        this.BackImgFile = "";
        this.BackImgName = "";
        this.agreecheck = false;
        if (this.selproof == "Aadhaar") {
            this.TrustFrontImgFile = 'assets/images/aadhaar.png';
            this.TrustBackImgFile = 'assets/images/aadhaar.png';

        }
        else if (this.selproof == "Voter Id") {
            this.TrustFrontImgFile = 'assets/images/voter-id-card.png';
            this.TrustBackImgFile = 'assets/images/voterback.png';
        }
        else if (this.selproof == "PAN Card") {
            this.TrustFrontImgFile = 'assets/images/panuploadIcon.PNG';

        }
        else if (this.selproof == "Driving License") {
            this.TrustFrontImgFile = 'assets/images/drive.png';
            this.TrustBackImgFile = 'assets/images/driveback.png';
        }
        else if (this.selproof == "NREGA Job Card") {
            this.TrustFrontImgFile = 'assets/images/naregasample.png';
            this.TrustBackImgFile = 'assets/images/naregasample1.png';
        }
        else if (this.selproof == "Passport") {
            this.TrustFrontImgFile = 'assets/images/passportfront.jfif';
            this.TrustBackImgFile = 'assets/images/passportback.jpg';
        }
        else {
            this.TrustFrontImgFile = 'assets/images/other.png';
        }
    }

    segmentChangedRTD(ev) {
        this.FronImgName = "";
        this.FrontImgFile = "";
        this.BackImgFile = "";
        this.BackImgName = "";
        this.Filearray = [];
        this.agreecheck = false;
        this.formsubmitted = false;
        this.addressform.reset();
        if (ev.detail.value == 'permanent') {
            this.segment = 'permanent'
        }
        else {
            this.segment = 'correspondance'
        }
        console.log(ev)
    }





    async changeAddressType(selected) {
        this.FronImgName = "";
        this.FrontImgFile = "";
        this.BackImgFile = "";
        this.BackImgName = "";
        this.Filearray = [];
        this.agreecheck = false;
        this.formsubmitted = false;
        this.addressform.reset();
        this.segment = selected;
        //    alert(this.segment);
        /*
                if (selected == 'permanent') {
                    this.segment = 'permanent'
                    alert(this.profileDtls.permanentAddress);
                }
                else if(selected == 'correspondance') {
                    this.segment = 'correspondance'
                    console.log(this.profileDtls.correspondanceAddress);
                }
                else{
                    this.segment = 'both'
                }
        */
    }


    async presentModal() {
        const modal = await this.modalCtrl.create({
            component: CountryListModal,
        });
        modal.onDidDismiss()
            .then((data) => {
                console.log("dismiss", data);
                if (data['data'] != undefined) {
                    // let cn = data['data'];
                    this.country = data['data'];
                    this.checkpincode();
                    console.log(this.country)
                }
            });
        return await modal.present();
    }


    pickImage(sourceType) {
        let date = new Date();
        const options: CameraOptions = {
            quality: localStorage.imagequality,
            sourceType: sourceType,
            destinationType: this.camera.DestinationType.DATA_URL,
            encodingType: this.camera.EncodingType.JPEG,
            mediaType: this.camera.MediaType.PICTURE
        }
        this.camera.getPicture(options).then(async (imageData) => {
            if (this.platform.is('ios')) {
                await this.statusBar.overlaysWebView(true);
                await this.statusBar.overlaysWebView(false);
            }
            let base64Image = 'data:image/jpeg;base64,' + imageData;
            let stringLength: number = Number(imageData.length);
            let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
            let sizeInMB = sizeInBytes / 1000000;
            if (Math.floor(sizeInMB) <= Number(localStorage.imgsize)) {
                if (imageData.indexOf("file:/") != -1) {
                    this.base64.encodeFile(imageData).then((base64File: string) => {
                        if (this.FileSelected == "front") {
                            this.FronImgName = imageData.substring(imageData.lastIndexOf("/"), imageData.length);
                            this.TrustFrontImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
                            this.FrontImgFile = base64File;
                        } else {
                            this.BackImgName = imageData.substring(imageData.lastIndexOf("/"), imageData.length);
                            this.BackImgFile = base64File;
                            this.TrustBackImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
                        }
                    });
                } else {
                    if (this.FileSelected == "front") {
                        this.FronImgName = "IMG_" + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() + ".jpeg",
                            this.TrustFrontImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64Image);
                        this.FrontImgFile = base64Image;
                    } else {
                        this.BackImgName = "IMG_" + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() + ".jpeg",
                            this.TrustBackImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64Image);
                        this.BackImgFile = base64Image;
                    }
                }
            } else
                this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid");

        }, async(err) => {
            if (this.platform.is('ios')) {
                await this.statusBar.overlaysWebView(true);
                await this.statusBar.overlaysWebView(false);
              }
        });
    }

    async IOSFileselect() {
        let filePath: any;
        let fileName: any;
        let path: any;
        let validFormate: any;
        let stringLength: any;
        await this.iosfilepicker.pickFile().then(async uri => {
            filePath = "file://" + uri;
            fileName = filePath.split('/').pop();
            path = filePath.substring(0, filePath.lastIndexOf("/") + 1);
            this.file.readAsDataURL(path, fileName).then(base64File => {
                sessionStorage.demo = base64File;
                validFormate = fileName.substring(fileName.lastIndexOf("."), fileName.length);
                if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
                    stringLength = base64File.substring(base64File.indexOf("64,") + 3, base64File.length);
                    stringLength = stringLength.length;
                    let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
                    let sizeInMB = sizeInBytes / 1000000;
                    if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
                        if (this.FileSelected == "front") {
                            this.FronImgName = fileName;
                            this.FrontImgFile = base64File;
                            if (validFormate.toLowerCase() == ".pdf")
                                this.TrustFrontImgFile = "assets/images/pdfimg.PNG"
                            else
                                this.TrustFrontImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
                        } else {
                            this.BackImgName = fileName;
                            this.BackImgFile = base64File;
                            if (validFormate.toLowerCase() == ".pdf")
                                this.TrustBackImgFile = "assets/images/pdfimg.PNG"
                            else
                                this.TrustBackImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
                        }
                    } else
                        this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid");
                } else
                    this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].invalidImage, "invalid");
            })
                .catch(() => {
                    console.log('Error reading file');
                })
        })
            .catch(err => console.log('Error', err));
    }

    Fileselect() {
        let validFormate: any;
        let stringLength: any;
        if (this.platform.is('android')) {
            this.fileChooser.open()
                .then(
                    uri => {
                        this.filePath.resolveNativePath(uri)
                            .then(url => {
                                var fileName = url.substring(url.lastIndexOf("/") + 1);

                                validFormate = url.substring(url.lastIndexOf("."), url.length);
                                if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
                                    this.base64.encodeFile(url).then((base64File: string) => {
                                        if (validFormate.toLowerCase() == ".pdf") {
                                            stringLength = base64File.indexOf("64,") + 3;
                                            base64File = "data:application/pdf;base64," + base64File.substring(stringLength, base64File.length);
                                            stringLength = base64File.length - 'data:application/pdf;base64,'.length;
                                        } else
                                            stringLength = base64File.length - 'data:image/png;base64,'.length;
                                        let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
                                        let sizeInMB = sizeInBytes / 1000000;
                                        if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
                                            if (this.FileSelected == "front") {
                                                this.FronImgName = fileName;
                                                if (validFormate.toLowerCase() == ".pdf")
                                                    this.TrustFrontImgFile = "assets/images/pdfimg.PNG"
                                                else
                                                    this.TrustFrontImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
                                                this.FrontImgFile = base64File;
                                            } else {
                                                this.BackImgName = fileName;
                                                if (validFormate.toLowerCase() == ".pdf")
                                                    this.TrustBackImgFile = "assets/images/pdfimg.PNG";
                                                else
                                                    this.TrustBackImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
                                                this.BackImgFile = base64File;
                                            }
                                        }
                                        else {
                                            this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid")
                                        }
                                    });
                                } else {
                                    this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].invalidImage, "invalid")
                                }

                            })
                            .catch(err => console.log(err));
                    }
                )
                .catch(error => {
                    console.log(error)
                });
        }
    }

    async selectImage(flg: any) {
        this.FileSelected = flg
        this.cmndeclaration.Actionsheetenable = true;
        const actionSheet = await this.actionSheetController.create({
            header: "Select Image source",
            buttons: [{
                text: 'Load from Library',
                handler: () => {
                    this.cmndeclaration.Actionsheetenable = false;
                    if (this.cmndeclaration.runPlatform == 'ios')
                        this.IOSFileselect();
                    else
                        this.Fileselect();
                }
            },
            {
                text: 'Use Camera',
                handler: () => {
                    this.cmndeclaration.Actionsheetenable = false;
                    this.pickImage(this.camera.PictureSourceType.CAMERA);
                }
            },
            {
                text: 'Cancel',
                role: 'cancel',
                handler: () => {
                    this.cmndeclaration.Actionsheetenable = false;
                  }
            }
            ]
        });
        await actionSheet.present();
    }

    checkpincode() {
        let res: any;
        let req: any;


        if ((this.country).trim() == "India") {
            // this.maxLength =6
            if (this.pincode.length == 6) {

                req = {
                    pinCode: this.pincode
                }
                this.api.postapi("verifyPincode", req).then(data => {
                    // this.inputElement.setFocus();
                    res = data;
                    if (res.message == 'Valid Pin Code')
                        this.validPin = true;
                    else
                        this.validPin = false;
                }, err => {
                    console.log(err);
                })
            }
            else {
                this.validPin = false
            }
        } else {
            // this.maxLength =15
            this.validPin = false;
        }
    }

    async updateAddress() {
        console.log(this.selproof);
        if (this.addressform.valid && (this.validPin || (this.country).trim() != "India")) {
            if (this.selproof != undefined || this.selproof != null || this.selproof != "") {
                if ((this.selproof == "Aadhaar" && this.agreecheck == false))
                    return;
                if (this.selproof == "Aadhaar" || this.selproof == "Driving License" || this.selproof == "Voter Id" || this.selproof == "Passport" || this.selproof == "NREGA Job Card") {
                    this.Filearray = [];
                    if (this.FrontImgFile != '' && this.FrontImgFile != undefined && this.BackImgName != '' && this.BackImgName != undefined) {
                        this.Filearray.push({
                            "fileContent": this.FrontImgFile,
                            "fileContentName": this.FronImgName,

                        });
                        this.Filearray.push({
                            "fileContent": this.BackImgFile,
                            "fileContentName": this.BackImgName,

                        })
                    }
                }
                else {

                    if (this.FrontImgFile != '' && this.FrontImgFile != undefined) {
                        this.Filearray.push({
                            "fileContent": this.FrontImgFile,
                            "fileContentName": this.FronImgName,

                        });
                    }
                }
                if (this.addressform.valid && (((this.selproof == "Aadhaar" || this.selproof == "Driving License" || this.selproof == "Voter Id" || this.selproof == "Passport" || this.selproof == "NREGA Job Card") && this.Filearray.length == 2) || this.Filearray.length == 1)) {
                    // await this.cmndef.loaderstart();
                    var data = {
                        "actionType": "OTPREQUEST",
                        "userSessionID": localStorage.userSessionID,
                        "userChatSessionID": localStorage.userChatSessionId
                    };

                    this.api.clickenventcap("submit_" + this.cmndef.TrakcerFromValue[this.cmndef.router.url]);
                    this.api.postapi("otpRequest", data).then(res => {
                        if (res['message'] != undefined)
                            this.cmndef.Showtoast(res['message']);
                        localStorage.state = res['state'];
                        this.senddatawithotp(localStorage);
                    }, err => {
                        console.log(err);
                    })
                }
            }
        }
    }

    senddatawithotp(localStorage) {
        var add = this.addressform.value.address + ' ' + this.addressform.value.city + ' ' + this.addressform.value.state + ' ' + this.addressform.value.country + ' ' + this.addressform.value.pincode;
        add = add.toString();
        var AddressDetails = {
            "Address": add,
            "AddressType": this.segment
        }
        let senddata = {};

        senddata['userSessionID'] = localStorage.userSessionID;
        senddata['AddressDetails'] = AddressDetails;
        senddata['userChatSessionID'] = localStorage.userChatSessionId;
        senddata['actionType'] = 'ADDRESS_UPDATE';
        senddata['verficationType'] = 'IDProof';
        senddata['ProofType'] = this.selproof;
        senddata['fileContent'] = this.Filearray;
        this.cmndef.addressparams = JSON.stringify(senddata);
        this.cmndef.previousPage = this.currentpath;
        sessionStorage.CurrentPage = "/verifyOtpaddress";
        this.navctrl.navigateForward("/verifyOtpaddress")
        if (this.profileDtls.emailID != '' && this.profileDtls.mobileNo != '') {
            this.cmndef.Showtoast(this.languageConext.otpsendreq.error);
        }//both mobile and email
        else if (this.profileDtls.emailID == '' && this.profileDtls.mobileNo != '') {
            this.cmndef.Showtoast(this.languageConext.otpsendreqmmobile.error);
        }// if only mobile
        else if (this.profileDtls.emailID != '' && this.profileDtls.mobileNo == '') {
            this.cmndef.Showtoast(this.languageConext.otpsendreqmemail.error);
        }//if only email

        /* if any messge is to be printed after sending the details, add to the chat array here*/
    }

    validatefun(event: any, flg: any) {
        if (flg == 'pincode') {
            this.pincode = this.pincode.replace(/[^0-9]/g, '');
        }
        else if (flg == 'city') {
            this.city = this.city.replace(/[^a-zA-Z ]+/g, '');
        }
        else if (flg == 'state') {
            this.state = this.state.replace(/[^a-zA-Z ]+/g, '');
        }
        else if (flg == 'address') {
            this.address = this.address.replace(/[^a-zA-Z0-9!@#$%^&*()<>,.?/ ]+/g, '');
        }

    }

    changeListener($event, flg): void {
        let name: any;
        let validFormate: any;
        let imgname: any;
        let sizeInBytes: any;
        let stringLength: any;
        let sizeInMB: any;
        name = $event.target.files[0].name;
        this.FileSelected = flg;
        validFormate = name.substring(name.lastIndexOf("."), name.length);
        if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
            this.cmndef.readThis($event.target).then(data => {
                imgname = data;
                stringLength = imgname.length - imgname.indexOf("64,") + 3;
                sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
                sizeInMB = sizeInBytes / 1000000;
                console.log(sizeInMB);
                if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
                    if (this.FileSelected == "front") {
                        this.FronImgName = name;
                        this.FrontImgFile = imgname;
                        if (validFormate.toLowerCase() == ".pdf")
                            this.TrustFrontImgFile = "assets/images/pdfimg.PNG"
                        else
                            this.TrustFrontImgFile = this._DomSanitizer.bypassSecurityTrustUrl(imgname);
                    } else {
                        this.BackImgName = name;
                        this.BackImgFile = imgname;
                        if (validFormate.toLowerCase() == ".pdf")
                            this.TrustBackImgFile = "assets/images/pdfimg.PNG"
                        else
                            this.TrustBackImgFile = this._DomSanitizer.bypassSecurityTrustUrl(imgname);
                    }
                } else {
                    this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid")
                }
            })
        } else {
            this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].invalidImage, "invalid")
        }
    }






}